export const getDynamicBreadcrumbKey = (dynamicBreadcrumb) => `${dynamicBreadcrumb.paramId}|${dynamicBreadcrumb.paramValue}`;
